import { useState, useEffect } from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import api from '@/utils/api';

const PriceTicker = ({ className = '' }) => {
  const [prices, setPrices] = useState([]);

  useEffect(() => {
    const fetchPrices = async () => {
      try {
        const res = await api.get('/market/live-prices');
        setPrices(res.data.prices || []);
      } catch (error) {
        // Live pricing is a non-critical enhancement; fail silently.
      }
    };

    fetchPrices();
    const interval = setInterval(fetchPrices, 30000);
    return () => clearInterval(interval);
  }, []);

  if (prices.length === 0) return null;

  return (
    <div className={`flex flex-wrap gap-3 ${className}`} data-testid="price-ticker">
      {prices.map((coin) => {
        const isUp = coin.change_24h >= 0;
        return (
          <div
            key={coin.symbol}
            className="flex items-center gap-2 bg-card border border-border rounded-sm px-4 py-2 font-mono"
          >
            <span className="text-foreground font-bold">{coin.symbol}</span>
            <span className="text-secondary-foreground">
              ${coin.price >= 1 ? coin.price.toLocaleString(undefined, { maximumFractionDigits: 2 }) : coin.price.toPrecision(4)}
            </span>
            <span className={`flex items-center gap-1 text-xs ${isUp ? 'text-profit' : 'text-loss'}`}>
              {isUp ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}
              {Math.abs(coin.change_24h).toFixed(2)}%
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default PriceTicker;
